import EquipmentClassFormatter from './EquipmentClassFormatter'

export default EquipmentClassFormatter
